module.exports = __webpack_public_path__ + "static/media/ic_recipes.f403ee53.svg";